export const shouldShowPremiumRequired = (isAppRequiredPremium, isPremiumSite) => {
    return isAppRequiredPremium && !isPremiumSite;
};
//# sourceMappingURL=app-info-badge.util.js.map